import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";
import "./App.css";

import LandingPage from "./Components/MainPages/LandingPage";
// import QRCodeGenerator from "./Components/MainPages/QRCodeGenerator";
import SportSelect from "./Components/MainPages/SportSelect";
import Dec2025_Womens_T20Team from "./Components/MainPages/Dec2025_Womens_T20Team";
import Kabaddi from "./Components/MainPages/Kabaddi";
import Hockey from "./Components/MainPages/Hockey";
import Basketball from "./Components/MainPages/Basketball";
import Football from "./Components/MainPages/Football";
import Volleyball from "./Components/MainPages/Volleyball";
import Dec2025_Womens_T20Individual from "./Components/MainPages/Dec2025_Womens_T20Individual";
import IndividualFootball from "./Components/MainPages/IndividualFootball";
import IndividualKabaddi from "./Components/MainPages/IndividualKabaddi";
import IndividualHockey from "./Components/MainPages/IndividualHockey";
import IndividualBasketball from "./Components/MainPages/IndividualBasketball";
import IndividualVolleyball from "./Components/MainPages/IndividualVolleyball";
import Contact from "./Components/MainPages/Contact";
import RegistrationPolicies from "./Components/MainPages/RegistrationPolicies";
import MissingChildrenPolicy from "./Components/MainPages/MissingChildrenPolicy";
import SportsDocuments from "./Components/MainPages/SportsDocuments";
import AboutTPL from "./Components/MainPages/AboutTPL";
import CricketHomepage from './Components/MainPages/CricketHomepage';
import OurOfferings from "./Components/MainPages/OurOfferings";
import PlayersSection from "./Components/MainPages/PlayersSection";
import SportsBlogPage from "./Components/MainPages/SportsBlogPage";
import EventHomepage from "./Components/MainPages/EventHomepage";
import Dec2025_Womens_T20EventSelect from "./Components/MainPages/Dec2025_Womens_T20EventSelect";
import AtplSelectType from "./Components/MainPages/AtplSelectType";
import MensCricketTeam from "./Components/MainPages/MensCricketTeam";
import MensCricketIndividual from "./Components/MainPages/MensCricketIndividual";
import Sponsorform from "./Components/MainPages/Sponsorform";
import AattumGallery from "./Components/MainPages/AattumGallery";

// 🔹 Navbars & Footer
import Navbar from "./Components/MainPages/Navbar";
import AdminNavbar from "./Components/MainPages/admin/AdminNavbar";
import Footer from "./Components/MainPages/Footer";

// 🔹 Admin Components
import AdminLogin from "./Components/MainPages/admin/AdminLogin";
import AdminDashboard from "./Components/MainPages/admin/AdminDashboard";
import ReportsPage from "./Components/MainPages/admin/Reports/ReportsPage";
import AdminUserManagement from "./Components/MainPages/admin/Management/AdminUserManagement";
import ProtectedRoute from "./Components/MainPages/admin/ProtectedRoute";
import AtplMensEventReport from "./Components/MainPages/admin/AtmEventReport/AtplMensEventReport";
import Dec2025_Womens_T20EventReport from "./Components/MainPages/admin/AtmEventReport/Dec2025_Womens_T20EventReport";

function LayoutWrapper({ children }) {
  const location = useLocation();
  const path = location.pathname;

  // 🔹 Admin-only paths
  const adminRoutes = ["/dashboard", "/report", "/usermanagement", "/Men'sT20", "/Dec2025_Womens_T20-report"];

  // 🔹 Sports pages
  const isSportsRoute =
    path.startsWith("/cricket-home") ||
    path.match(/\/(cricket|football|kabaddi|hockey|basketball|volleyball)-(form|individual-form)\//);

  const isAdminDashboardRoute = adminRoutes.includes(path);
  const isAdminLogin = path === "/admin";

  return (
    <>
      {/* ✅ Conditional Navbar */}
      {isAdminLogin ? null : isAdminDashboardRoute ? (
        <AdminNavbar />
      ) : isSportsRoute ? (
        <Navbar />
      ) : (
        <Navbar />
      )}

      {children}

      {/* ✅ Footer visible on all except /admin and admin dashboard routes */}
      {!isAdminLogin && !isAdminDashboardRoute && <Footer />}
    </>
  );
}




function App() {
  const [isAdmin, setIsAdmin] = useState(localStorage.getItem("isAdmin") === "true");

  useEffect(() => {
    const handleStorageChange = () => {
      setIsAdmin(localStorage.getItem("isAdmin") === "true");
    };
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  return (
    <Router>
      <LayoutWrapper>
        <Routes>
          {/* 🌍 Public Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/register" element={<SportSelect />} />
          {/* <Route path="/QRCodeGenerator" element={<QRCodeGenerator />} /> */}
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/tplpolicies" element={<RegistrationPolicies />} />
          <Route path="/tplchildrenpolicies" element={<MissingChildrenPolicy />} />
          <Route path="/sports-documents" element={<SportsDocuments />} />
          <Route path="/about-tpl" element={<AboutTPL />} />
          <Route path="/blogs" element={<SportsBlogPage />} />
          <Route path="/Eventhomepage" element={<EventHomepage />} />
          <Route path="/Dec2025_Womens_T20-register" element={<Dec2025_Womens_T20EventSelect />} />
          <Route path="/Atplform" element={<AtplSelectType />} />
          <Route path="/sponsor" element={<Sponsorform />} />
          <Route path="/AtplGallery" element={<AattumGallery />} />

          {/* 🏏 Sports Forms */}
          <Route path="/cricket-form/:userId" element={<Dec2025_Womens_T20Team />} />
          <Route path="/AtplMensForm/:userId" element={<MensCricketTeam />} />
          <Route path="/kabaddi-form/:userId" element={<Kabaddi />} />
          <Route path="/hockey-form/:userId" element={<Hockey />} />
          <Route path="/basketball-form/:userId" element={<Basketball />} />
          <Route path="/football-form/:userId" element={<Football />} />
          <Route path="/volleyball-form/:userId" element={<Volleyball />} />


          {/* 🧍‍♂️ Individual Forms */}
          <Route path="/cricket-individual-form/:userId" element={<Dec2025_Womens_T20Individual />} />
          <Route path="/Atplmensindividual/:userId" element={<MensCricketIndividual />} />
          <Route path="/kabaddi-individual-form/:userId" element={<IndividualKabaddi />} />
          <Route path="/hockey-individual-form/:userId" element={<IndividualHockey />} />
          <Route path="/basketball-individual-form/:userId" element={<IndividualBasketball />} />
          <Route path="/football-individual-form/:userId" element={<IndividualFootball />} />
          <Route path="/volleyball-individual-form/:userId" element={<IndividualVolleyball />} />

          {/* 🏆 Sports Home */}

          <Route path='/cricket-homepage' element={<CricketHomepage />} />
          <Route path='/our-offerings' element={<OurOfferings />} />
          <Route path='/player-section' element={<PlayersSection />} />

          {/* 🧩 Admin Routes */}
          <Route path="/admin" element={<AdminLogin setIsAdmin={setIsAdmin} />} />
          <Route path="/dashboard" element={<ProtectedRoute isAuth={isAdmin} element={<AdminDashboard />} />} />
          <Route path="/report" element={<ProtectedRoute isAuth={isAdmin} element={<ReportsPage />} />} />
          <Route path="/usermanagement" element={<ProtectedRoute isAuth={isAdmin} element={<AdminUserManagement />} />} />
          <Route path="/Men'sT20" element={<ProtectedRoute isAuth={isAdmin} element={<AtplMensEventReport />} />} />
              <Route path="/Dec2025_Womens_T20-report" element={<ProtectedRoute isAuth={isAdmin} element={<Dec2025_Womens_T20EventReport />} />} />
        </Routes>
      </LayoutWrapper>
    </Router>
  );
}

export default App;
